import { render, staticRenderFns } from "./UserDropdownButtons.vue?vue&type=template&id=0d94365c&scoped=true&"
import script from "./UserDropdownButtons.vue?vue&type=script&lang=js&"
export * from "./UserDropdownButtons.vue?vue&type=script&lang=js&"
import style0 from "./UserDropdownButtons.vue?vue&type=style&index=0&id=0d94365c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d94365c",
  null
  
)

export default component.exports